import {
    CONSENT_FORM_SUMBITED
  } from "./actionTypes"

  export const concentFormSubmit = (request) => {
    return {
      type: CONSENT_FORM_SUMBITED,
      payload: request
    }
  }